// Порт ref useOverflowDetection: макет телефона фиксированной высоты, поэтому
// уровень (`fits`/`warn`/`over`) решает `designOverflowLevel` по высоте контента
// относительно контейнера. MutationObserver ловит правки
// текста и добавление элементов, ResizeObserver — изменение размеров.
// Принимает НОД (не ref-объект): DesignCanvas рендерит наблюдаемый div только
// когда есть хотя бы один элемент (пустое состояние — другая разметка), а
// стабильный RefObject в deps не перезапускает эффект при появлении узла —
// поэтому наблюдение цепляется за смену самого узла через callback-ref/стейт.
import { useEffect, useState } from 'react'
import { designOverflowLevel, type DesignOverflowLevel } from '../../../../lib/designOverflowMeasure'

export const useOverflowDetection = (el: HTMLElement | null): DesignOverflowLevel => {
  const [level, setLevel] = useState<DesignOverflowLevel>('fits')

  useEffect(() => {
    if (!el) {
      setLevel('fits')
      return
    }
    const check = () => setLevel(designOverflowLevel(el))
    check()
    const ro = new ResizeObserver(check)
    ro.observe(el)
    const mo = new MutationObserver(() => requestAnimationFrame(check))
    mo.observe(el, { childList: true, subtree: true, characterData: true, attributes: true })
    return () => {
      ro.disconnect()
      mo.disconnect()
    }
  }, [el])

  return level
}
